import React, { useState } from "react";
import { TextField, Button, Typography, Box, Container } from "@mui/material";

const DryMatterConversionTool = () => {
  const [moisture, setMoisture] = useState("");
  const [asFed, setAsFed] = useState("");
  const [result, setResult] = useState(null);

  const handleCalculate = () => {
    if (moisture && asFed) {
      const moistureValue = parseFloat(moisture);
      const asFedValue = parseFloat(asFed);

      if (moistureValue < 0 || moistureValue >= 100 || isNaN(moistureValue)) {
        alert("Please enter a valid moisture percentage (0-100).");
        return;
      }
      if (asFedValue < 0 || isNaN(asFedValue)) {
        alert("Please enter a valid as-fed percentage.");
        return;
      }

      // Calculate dry matter basis % value
      const dryMatterBasis = (asFedValue / (100 - moistureValue)) * 100;
      setResult(dryMatterBasis.toFixed(2));
    }
  };

  return (
    <Container>
      <Box sx={{ mt: 0 }}>
        <Typography variant="h6" gutterBottom>
          Dry Matter Conversion Tool
        </Typography>

        <TextField
          label="Moisture %"
          type="number"
          value={moisture}
          onChange={(e) => setMoisture(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
        />

        <TextField
          label="As-Fed %"
          type="number"
          value={asFed}
          onChange={(e) => setAsFed(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleCalculate}
          sx={{ mt: 2 }}
        >
          Calculate
        </Button>

        {result !== null && (
          <Typography variant="body1" sx={{ mt: 2 }}>
            Dry Matter Basis %: {result}%
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default DryMatterConversionTool;